import {
  Cto,
  CtoGrid,
  CTOsPerTagListResponse,
  CtoStatus,
  CtoSummary,
  HeaderStatus,
  Sort,
  Step5Response,
  Step6Response,
} from "../../types";
import {
  getCancelledHeaderStatus,
  getCompletedHeaderStatus,
  getExpiredHeaderStatus,
  getExtensionRequiredHeaderStatus,
  getLiveHeaderStatus,
  getUnderEvaluationHeaderStatus,
  isAvailableCtoFilling,
} from "../../utils";

export const ctoToCtoGrid = (cto: Cto): CtoGrid => ({
  ...cto,
  finalDate: cto.final_date ? new Date(cto.final_date) : undefined,
  cto_id: cto.cto_id ?? cto.cto_code,
  merge_status: cto.merge_status ?? null,
  tags: cto.tags?.map((tag) => tag.tag_code) || [],
  sces: cto.sces?.map((sce) => sce.sce_code) || [],
  //TODO - CHECK TYPESCRIPT FIX
  cto_title: "",
  machine_version: 2,
});

export const ctosToCtoGridList = (ctos?: Cto[]): CtoGrid[] => {
  if (ctos && Array.isArray(ctos)) {
    return ctos.map(ctoToCtoGrid);
  }
  return [];
};

export const ctosToCtoGridListOrderly = (ctos?: Cto[]): CtoGrid[] => {
  if (!ctos || !Array.isArray(ctos) || ctos.length === 0) {
    return [];
  }

  const gridList = ctosToCtoGridList(ctos);

  return gridList.sort(
    (a, b) =>
      sortCtoByStatus(a.status, b.status) ||
      sortByEarliestDate(
        a.finalDate ? new Date(a.finalDate) : undefined,
        b.finalDate ? new Date(b.finalDate) : undefined,
      ) ||
      (a.created_at && b.created_at
        ? new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
        : 0),
  );
};

export const ctoByTagToSetCtos = (
  ctos: CTOsPerTagListResponse[],
): Map<string, string[]> => {
  const ctoToResponse = new Map<string, string[]>([]);
  ctos?.forEach((item) => {
    item.ctos.forEach((cto) => {
      const value = ctoToResponse.get(cto);

      value
        ? ctoToResponse.set(cto, [...new Set([...value, item.tagCode])])
        : ctoToResponse.set(cto, [item.tagCode]);
    });
  });

  return ctoToResponse;
};

export const orderRecommendations = (
  recommendations: Step6Response | Step5Response,
): Step6Response | Step5Response => {
  recommendations.assigning_recommendations.sort(
    (a, b) => a.recommendation_id - b.recommendation_id,
  );
  return recommendations;
};

export const sortByEarliestDate = (dateA?: Date, dateB?: Date) => {
  if (!dateB) return Sort.EQUAL;
  if (!dateA) return Sort.EQUAL;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  //Calcula a diferença em milissegundos
  const diff1 = Math.abs(dateA.getTime() - today.getTime());
  const diff2 = Math.abs(dateB.getTime() - today.getTime());

  if (diff1 < diff2) return Sort.A_FIRST;
  if (diff1 > diff2) return Sort.B_FIRST;

  return Sort.EQUAL;
};

export const sortCtoByStatus = (
  statusA: CtoStatus,
  statusB: CtoStatus,
): Sort => {
  if (isAvailableCtoFilling(statusA) === isAvailableCtoFilling(statusB))
    return Sort.EQUAL;
  return isAvailableCtoFilling(statusA) ? Sort.A_FIRST : Sort.B_FIRST;
};

export const getCtoStatusCountByVessel = (
  ctos: CtoSummary[],
  vesselCode: string,
): HeaderStatus[] => {
  const summaryByVessel = ctos.find(
    ({ vessel_code }) => vessel_code === vesselCode,
  );
  return toHeaderStatus(summaryByVessel);
};

export const toHeaderStatus = (cto: CtoSummary | undefined): HeaderStatus[] => [
  getCompletedHeaderStatus(cto?.COMPLETED),
  getUnderEvaluationHeaderStatus(cto?.UNDER_EVALUATION),
  getLiveHeaderStatus(cto?.LIVE),
  getCancelledHeaderStatus(cto?.CLOSED),
  getExtensionRequiredHeaderStatus(cto?.EXTENSION_REQUIRED),
  getExpiredHeaderStatus(cto?.EXPIRED),
];
